import { PoliciesTranslations } from '~domain/i18n/english/policies';

export const policies: PoliciesTranslations = {
  attachments: {
    types: {
      newBusinessPaymentSchedule: "Calendrier de paiement d'une nouvelle police d'assurance",
      policyChangePaymentSchedule: 'Calendrier de paiement après une modification de police',
      renewalPaymentSchedule: 'Calendrier de paiement pour le renouvellement',
      reissuePaymentSchedule: 'Calendrier de paiement suite à une réémission',
      rewritePaymentSchedule: 'Calendrier de paiement pour une seconde souscription',
      reinstatementPaymentSchedule: 'Calendrier de paiement suite à une remise en vigueur',
      paymentScheduleNoPolicyTransaction: 'Calendrier de paiement non associé à une opération sur la police',
      billingWithdrawalRejectionNotice: 'Avis de refus de prélèvement automatique',
      billingOverduePaymentNotice: 'Avis de paiement en retard',
      billingFinalBillNotice: 'Avis de facturation finale',
      billingRefundIssued: 'Remboursement de facturation émis',
      paymentReceivedPolicyReinstated: 'Paiement reçu et police remise en vigueur',
      paymentRequiredOutstandingBalance: 'Paiement requis pour solde impayé',
      billingCollectionNotice: 'Avis de recouvrement de la facture impayée',
      billingCreditCardExpired: 'Expiration de la carte de crédit utilisée pour le paiement des factures',
      insurerNonRenewal: 'Non-renouvellement de la part de l’assureur',
      insurerCancellationReinstatable: "Annulation de la part de l'assureur avec possibilité de remise en vigueur",
      insurerCancellationDefinitive: "Annulation de la part de l'assureur sans possibilité de remise en vigueur",
      insuredCancellationRequest: "Demande d'annulation par l’assuré",
      insurerCancellation: "Police annulée par l'assureur",
      newBusinessPolicyDeclaration: "Police d'assurance pour nouvelle affaire",
      newBusinessLiabilityCertificates: 'Certificats d’assurance responsabilité pour nouvelle affaire',
      policyChangePolicyDeclaration: "Police d'assurance suite à une modification de police",
      policyChangeLiabilityCertificates: "Certificats d'assurance responsabilité suite à une modification de police",
      renewalPolicyDeclaration: "Police d'assurance pour police renouvelée",
      renewalLiabilityCertificates: "Certificats d'assurance responsabilité pour police renouvelée",
      reissuePolicyDeclaration: "Police d'assurance pour police réémise",
      reissueLiabilityCertificates: "Certificats d'assurance responsabilité suite à une réémission de police",
      rewritePolicyDeclaration: "Police d'assurance pour police souscrite à nouveau",
      rewriteLiabilityCertificates: "Certificats d'assurance responsabilité pour police souscrite à nouveau",
      reinstatementPolicyDeclaration: "Police d'assurance pour police remise en vigueur",
      reinstatementLiabilityCertificates: "Certificats d'assurance responsabilité suite à une remise en vigueur",
      underwritingRequest: 'Demande de la souscription',
      claimOpeningNotice: "Avis d'ouverture du dossier de sinistre",
      claimClosingNotice: 'Avis de fermeture du dossier de sinistre',
      claimAdjusterAssignment: "Affectation de l'expert en sinistre",
      claimAutoRentalNotice: 'Avis de location de véhicule dans le cadre d’un sinistre',
      claimTotalLossNotice: 'Avis de sinistre pour perte totale',
      claimAutoFaultDeterminationNotice: 'Avis de détermination de responsabilité pour un sinistre automobile',
      claimPaymentNotice: 'Avis de paiement de sinistre',
      policyContract: "Contrat de police d'assurance",
      billingStatement: 'Relevé de comptes',
      billingNotice: 'Avis de facturation',
      cancellationNotice: "Avis d'annulation",
      okEDelivery: 'Ok - eDelivery',
      unknown: 'Inconnu',
    },
  },
};
